import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import UploadImage from '../../../helpers/components/ImageUpload'; // Replace this with your actual upload component
import './RecyclerInformationPage.css';
import { Eye, EyeOff } from 'lucide-react';
import CountryDropDown from '../../../helpers/countryDropDown';
import AutoCompleteAddress from '../../../helpers/components/AutoCompletePlace';
import clsx from 'clsx'
import { useEffect } from 'react';


interface IFSCDetails {
    BANK: string;
    BRANCH: string;
    ADDRESS: string;
    MICR: string;
    CITY: string;
    DISTRICT: string;
    STATE: string;
}


interface GSTDetails {
    legal_business_name: string;
    trade_name: string;
    principal_place_of_business: string;
    gstin_uin_status: string;
    gstin: string;
    constitution_of_business: string;
    taxpayer_type: string;
    effective_date_of_reg: string;
    state_jurisdiction_code: string;
    state_jurisdiction_ward: string;
    central_jurisdiction_code: string;
    central_jurisdiction_ward: string;
}


interface FormValues {
    stateCode: string;
    entityName: string;
    personName: string;
    // phoneNumber: string;
    email: string;
    password: string;
    street: string;
    city: string;
    state: string;  // Add this
    country: string;  // Add this
    zipcode: string;
    ifscCode: string;
    gstNumber: string;
    aadhar: string;
    panNumber: string;
    msmeFile: any;
    Cheque: any;
    PanU: any;
    gstCer: any;
    ifscDetails: IFSCDetails | null;
    accountNumber: string;
    accountHolderName: string;
    termsAccepted: boolean;
    platformPoliciesAccepted: boolean;
    latitute: number;
    longitute: number;
}
const RecyclerInformationPage: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();


    const [address, setAddress] = useState('')
    const [location, setlocation] = useState<any>({ lat: 0, lng: 0 })


    const [fileErrors, setFileErrors] = useState<{
        msmeFile?: string;
        Cheque?: string;
        gstCer?: string;
        PanU?: string;
    }>({});


    const stateCodeMapping = {
        'Andaman and Nicobar Islands': 'AN',
        'Andhra Pradesh': 'AP',
        'Arunachal Pradesh': 'AR',
        'Assam': 'AS',
        'Bihar': 'BH',
        'Chandigarh': 'CH',
        'Chhattisgarh': 'CT',
        'Dadra and Nagar Haveli': 'DN',
        'Daman and Diu': 'DD',
        'Delhi': 'DL',
        'Goa': 'GA',
        'Gujarat': 'GJ',
        'Haryana': 'HR',
        'Himachal Pradesh': 'HP',
        'Jammu and Kashmir': 'JK',
        'Jharkhand': 'JH',
        'Karnataka': 'KA',
        'Kerala': 'KL',
        'Lakshadweep': 'LD',
        'Madhya Pradesh': 'MP',
        'Maharashtra': 'MH',
        'Manipur': 'MN',
        'Meghalaya': 'ME',
        'Mizoram': 'MI',
        'Nagaland': 'NL',
        'Odisha': 'OR',
        'Puducherry': 'PY',
        'Punjab': 'PB',
        'Rajasthan': 'RJ',
        'Sikkim': 'SK',
        'Tamil Nadu': 'TN',
        'Telangana': 'TS',
        'Tripura': 'TR',
        'Uttar Pradesh': 'UP',
        'Uttarakhand': 'UT',
        'West Bengal': 'WB'
    };



    const [gstLoading, setGstLoading] = useState(false);
    const [gstValidated, setGstValidated] = useState(false);
    const [gstDetails, setGstDetails] = useState<GSTDetails | null>(null);
    const [showGstModal, setShowGstModal] = useState(false);

    // const validateGST = async (gstNumber) => {
    //     if (!gstNumber || !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gstNumber)) {
    //         formik.setFieldError('gstNumber', 'Invalid GST Number format');
    //         return;
    //     }

    //     setGstLoading(true);
    //     try {
    //         const response = await axios.get(
    //             `https://pfc-backend-api.asmglobal.co.in/v1/api/gst/validate/${gstNumber}`,
    //             {
    //                 headers: {
    //                     'accept': 'application/json',
    //                     'app-id': '3',
    //                     'client-id': '101212',
    //                 }
    //             }
    //         );

    //         if (response.data && response.data.data) {
    //             setGstDetails(response.data.data);
    //             setGstValidated(true);
    //             setShowGstModal(true);

    //             // Auto-fill form fields
    //             formik.setFieldValue('entityName', response.data.data.legal_business_name);
    //             setAddress(response.data.data.principal_place_of_business);
    //         }
    //     } catch (error) {
    //         formik.setFieldError('gstNumber', 'Invalid GST Number or verification failed');
    //         console.error('GST validation error:', error);
    //     } finally {
    //         setGstLoading(false);
    //     }
    // };







    // Validation Schema


    const validateGST = async (gstNumber) => {
        if (!gstNumber || !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gstNumber)) {
            formik.setFieldError('gstNumber', 'Invalid GST Number format');
            return;
        }

        setGstLoading(true);
        try {
            const response = await axios.get(
                `https://pfc-backend-api.asmglobal.co.in/v1/api/gst/validate/${gstNumber}`,
                {
                    headers: {
                        'accept': 'application/json',
                        'app-id': '3',
                        'client-id': '101212',
                    }
                }
            );

            if (response.data && response.data.data) {
                setGstDetails(response.data.data);
                setGstValidated(true);
                setShowGstModal(true);

                // Auto-fill form fields
                // formik.setFieldValue('entityName', response.data.data.legal_business_name);
                // Auto-fill form fields
                formik.setFieldValue('entityName', response.data.data.legal_business_name);
                formik.setFieldValue('personName', response.data.data.legal_business_name);
                const addressFromGST = response.data.data.principal_place_of_business;
                setAddress(addressFromGST);

                // Geocode the address to get lat/lng
                // Geocode the address to get lat/lng
                if (window.google && window.google.maps) {
                    const geocoder = new window.google.maps.Geocoder();
                    geocoder.geocode({ address: addressFromGST }, (results, status) => {
                        if (status === 'OK' && results && results[0] && results[0].geometry) {
                            const location = results[0].geometry.location;
                            const coords = {
                                lat: location.lat(),
                                lng: location.lng()
                            };
                            setlocation(coords);
                            formik.setFieldValue('latitute', coords.lat);
                            formik.setFieldValue('longitute', coords.lng);
                        }
                    });
                }
            }
        } catch (error) {
            formik.setFieldError('gstNumber', 'Invalid GST Number or verification failed');
            console.error('GST validation error:', error);
        } finally {
            setGstLoading(false);
        }
    };


    const validationSchema = Yup.object({
        entityName: Yup.string().required('Entity Name is required'),
        personName: Yup.string().required('Person Name is required'),
        // phoneNumber: Yup.string()
        //     .matches(/^[0-9]{10}$/, 'Phone number must be 10 digits')
        //     .required('Phone Number is required'),
        email: Yup.string()
            .email('Invalid email format')
            .required('Email is required'),
        street: Yup.string(),
        city: Yup.string().required('City is required'),
        password: Yup.string()
            .min(6, 'Password must be at least 6 characters')
            .required('Password is required'),
        zipcode: Yup.string()
            .matches(/^[0-9]{6}$/, 'Zipcode must be 6 digits')
            .required('Zipcode is required'),
        ifscCode: Yup.string()
            .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Invalid IFSC Code')
            .required('IFSC Code is required'),
        termsAccepted: Yup.boolean()
            .oneOf([true], 'You must accept the Terms of Service'),
        platformPoliciesAccepted: Yup.boolean()
            .oneOf([true], 'You must accept the Platform Policies'),
        gstNumber: Yup.string()
            .matches(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/, 'Invalid GST Number')
            .required('GST Number is required'),
        aadhar: Yup.string()
            .matches(/^[0-9]{12}$/, 'Aadhar must be 12 digits')
            .required('Aadhar is required'),
        panNumber: Yup.string()
            .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN Number')
            .required('PAN Number is required'),
        latitute: Yup.number().notRequired(), // or .required() if needed
        longitute: Yup.number().notRequired(), // or .required() if needed
        // accountNumber: Yup.string()
        //     .when('ifscDetails', {
        //         is: (val: any) => val !== null,
        //         then: Yup.string().required('Account Number is required'),
        //     }),
        // accountHolderName: Yup.string()
        //     .when('ifscDetails', {
        //         is: (val: any) => val !== null,
        //         then: Yup.string().required('Account Holder Name is required'),
        //     }),
    });

    const formik = useFormik<FormValues>({
        initialValues: {
            stateCode: '',
            state: '',
            country: '',
            entityName: '',
            personName: '',
            // phoneNumber: '',
            email: '',
            password: '',
            street: '',
            city: '',
            zipcode: '',
            ifscCode: '',
            gstNumber: '',
            aadhar: '',
            panNumber: '',
            msmeFile: null,
            Cheque: null,
            gstCer: null,
            PanU: null,
            ifscDetails: null,
            accountNumber: '',
            accountHolderName: '',
            termsAccepted: false,
            platformPoliciesAccepted: false,
            latitute: 0,
            longitute: 0
        },
        validationSchema,
        onSubmit: async (values) => {
            console.log('=== FORM ONSUBMIT CALLED ==='); // Add this line
            console.log('Values received:', values);
            const errors: {
                msmeFile?: string;
                Cheque?: string;
                gstCer?: string;
                PanU?: string;
            } = {};

            if (!values.msmeFile) errors.msmeFile = 'MSME Certificate is required';
            if (!values.Cheque) errors.Cheque = 'Cancel Cheque is required';
            if (!values.gstCer) errors.gstCer = 'GST Certificate is required';
            if (!values.PanU) errors.PanU = 'PAN document is required';

            console.log('File validation errors:', errors);
            setFileErrors(errors);

            // If there are file errors, don't submit
            if (Object.keys(errors).length > 0) {
                console.log('Stopping submission due to file errors');
                return;
            }


            try {
                setLoading(true);
                const payload = {
                    firstName: values.personName,
                    email: values.email,
                    mobile: String(JSON.parse(localStorage.getItem('verifiedPhoneNumber') || 'null')),
                    password: values.password,
                    userType: "RECYCLER",
                    countryCode: "91",
                    franchiseId: "",
                    status: "INACTIVE",
                    kycDocument: [
                        {
                            docUrl: "",
                            docNumber: values.aadhar,
                            docType: "AADHAR"
                        },
                        {
                            docUrl: values.gstCer,
                            docNumber: values.gstNumber,
                            docType: "GST_CERTIFICATE"
                        },
                        {
                            docUrl: values.PanU,
                            docNumber: values.panNumber,
                            docType: "PAN"
                        },
                        {
                            docNumber: "",
                            docUrl: values.msmeFile,
                            docType: "MSME_CERTIFICATE"
                        },
                    ],
                    companyDetails: {
                        name: values.entityName,
                        companyId: "",
                    },
                    address: [
                        {
                            addressType: "OFFICE_ADDRESS",
                            city: formik.values.city,
                            state: formik.values.state,
                            stateCode: formik.values.stateCode,
                            country: formik.values.country,
                            zipCode: values.zipcode,
                            street: address || '',
                            latitute: values.latitute,
                            longitute: values.longitute,

                        }
                    ],
                    bankDetails: {
                        bankName: values.ifscDetails?.BANK || "",
                        accountNo: values.accountNumber,
                        ifscCode: values.ifscCode,
                        accountName: values.accountHolderName,
                        images: [
                            {
                                // docNumber: "",
                                docUrl: values.Cheque,
                                docType: "CHEQUE_CERTIFICATE"
                            },
                        ]
                    }
                };
                console.log("Payload to be submitted:", payload);
                const response = await axios.post(
                    'https://pfc-backend-api.asmglobal.co.in/v1/api/user/register',
                    payload,
                    {
                        headers: {
                            'accept': 'application/json',
                            'app-id': '3',
                            'client-id': '101212',
                            'Connection': 'Keep-Alive',
                            'Content-Type': 'application/json',
                            'User-Agent': 'okhttp/4.9.2',
                        },
                    }
                );

                console.log(response.data);
                alert('User registered successfully!');
                navigate('/auth');

            } catch (error: any) {
                formik.setStatus(error?.response?.data?.message || 'Error registering user.');
                console.error(error);
            } finally {
                setLoading(false);
            }
        },
    });




    // Add this useEffect to watch for state changes
    useEffect(() => {
        if (formik.values.state && formik.values.country === 'India') {
            const code = stateCodeMapping[formik.values.state];
            if (code) {
                formik.setFieldValue('stateCode', code);
            }
        }
    }, [formik.values.state, formik.values.country]);


    const inputForm = ({
        label,
        name,
        placeholder,
        required = true,
        className = 'fw-bold fs-6 mb-2',
        disabled = false,
    }) => {
        return (
            <div className='fv-row mb-7'>
                <label className={`${required ? 'required' : ''} ${className}`}>{label}</label>
                <input
                    style={{ background: 'white', border: '1px solid rgb(204, 204, 204)' }}
                    placeholder={placeholder}
                    {...formik.getFieldProps(name)}
                    type='text'
                    name={name}
                    className={clsx(
                        'form-control form-control-solid mb-3 mb-lg-0',
                        { 'is-invalid': formik.touched[name] && formik.errors[name] },
                        {
                            'is-valid': (required && formik.touched[name] && !formik.errors[name]) || '',
                        }
                    )}
                    autoComplete='off'
                    disabled={formik.isSubmitting || disabled}
                />
                {formik.touched[name] && formik.errors[name] && (
                    <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                            <span role='alert'>{formik.errors[name]}</span>
                        </div>
                    </div>
                )}
            </div>
        )
    }

    const fetchIfscDetails = async () => {
        if (formik.values.ifscCode.trim() === '') {
            formik.setFieldError('ifscCode', 'Please enter a valid IFSC code');
            return;
        }

        setLoading(true);

        try {
            const response = await axios.get(`https://ifsc.razorpay.com/${formik.values.ifscCode}`);
            formik.setFieldValue('ifscDetails', response.data);
            console.log(response.data);
        } catch (error) {
            formik.setFieldError('ifscCode', 'Invalid IFSC code');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        formik.resetForm();
        navigate(-1);
    };
    const [showPassword, setShowPassword] = useState(false)
    const handleShowPassword = () => {
        setShowPassword(!showPassword)
    }
    return (
        <div className="recycler-page-container">
            <div className="logo-container">
                <img src="/logo.png" alt="Recycler" className="logo" />
            </div>
            <div className="recycler-form-container">
                <h2 className="recycler-title">Recycler Information</h2>
                <form onSubmit={formik.handleSubmit}>
                    <div className="form-content">
                        {/* Left Side Fields */}









                        <div className="form-column">




                            <div className="form-group">
                                <label className="form-label fw-bold" htmlFor="gstNumber">GST Number</label>
                                <div className="ifsc-container">
                                    <input
                                        type="text"
                                        id="gstNumber"
                                        {...formik.getFieldProps('gstNumber')}
                                        className={`ifsc-input ${formik.touched.gstNumber && formik.errors.gstNumber ? 'error' : ''}`}
                                    />
                                    <button
                                        type="button"
                                        onClick={() => validateGST(formik.values.gstNumber)}
                                        className="ifsc-search-button"
                                        disabled={gstLoading}
                                    >
                                        {gstLoading ? 'Validating...' : 'Validate'}
                                    </button>
                                </div>
                                {formik.touched.gstNumber && formik.errors.gstNumber && (
                                    <div className="error-message">{formik.errors.gstNumber}</div>
                                )}
                                {gstValidated && (
                                    <div style={{ color: '#22c55e', fontSize: '14px', marginTop: '4px' }}>
                                        ✓ GST Number validated successfully
                                    </div>
                                )}
                            </div>



                            <div className="form-group">
                                <label className="form-label fw-bold" htmlFor="entityName">Entity Name</label>
                                <input
                                    type="text"
                                    id="entityName"
                                    {...formik.getFieldProps('entityName')}
                                    className={`form-input ${formik.touched.entityName && formik.errors.entityName ? 'error' : ''}`}
                                    disabled={true}
                                />
                                {formik.touched.entityName && formik.errors.entityName && (
                                    <div className="error-message">{formik.errors.entityName}</div>
                                )}
                            </div>

                            <div className="form-group">
                                <label className="form-label fw-bold" htmlFor="personName">Representative Name</label>
                                <input
                                    type="text"
                                    id="personName"
                                    {...formik.getFieldProps('personName')}
                                    className={`form-input ${formik.touched.personName && formik.errors.personName ? 'error' : ''}`}
                                />
                                {formik.touched.personName && formik.errors.personName && (
                                    <div className="error-message">{formik.errors.personName}</div>
                                )}
                            </div>



                            <div className="form-group">
                                <label className="form-label fw-bold" htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    {...formik.getFieldProps('email')}
                                    className={`form-input ${formik.touched.email && formik.errors.email ? 'error' : ''}`}
                                />
                                {formik.touched.email && formik.errors.email && (
                                    <div className="error-message">{formik.errors.email}</div>
                                )}
                            </div>

                            <div className="form-group">
                                <label className="form-label fw-bold" htmlFor="password">Password</label>
                                <div className="relative">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        id="password"
                                        {...formik.getFieldProps('password')}
                                        className="form-input pr-10"
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        className="absolute right-3 top-1/2 -translate-y-1/2"
                                    >
                                        {showPassword ? (
                                            <EyeOff size={20} className="text-gray-500" />
                                        ) : (
                                            <Eye size={20} className="text-gray-500" />
                                        )}
                                    </button>
                                </div>
                                {formik.touched.password && formik.errors.password && (
                                    <div className="error-message">{formik.errors.password}</div>
                                )}
                            </div>



                            <CountryDropDown showState showCity name='country' formik={formik} showNameOnly />




                            {/* <div className='grid grid-cols-2 gap-2'>
                                {inputForm({
                                    label: 'Annual Processing Capacity (Matric Tons)',
                                    name: 'rigid',
                                    placeholder: 'Enter only values',
                                    required: selectedInCategoryDropdown?.some((x: any) => x.value === 'DIVERSION_FACILITY')
                                        ? true
                                        : false,
                                })}
                                <CountryDropDown showState showCity name='country' formik={formik} showNameOnly />
                            </div> */}




                            {/* <div className="form-group">
                                <label className="form-label fw-bold" htmlFor="street">Street</label>
                                <input
                                    type="text"
                                    id="street"
                                    {...formik.getFieldProps('street')}
                                    className={`form-input ${formik.touched.street && formik.errors.street ? 'error' : ''}`}
                                />
                                {formik.touched.street && formik.errors.street && (
                                    <div className="error-message">{formik.errors.street}</div>
                                )}
                            </div> */}
                            {/* 
                            <div className='grid'>
                                <div className='fv-row mb-7'>
                                    <label className=' fw-bold fs-6 mb-2'>Street</label>
                                    <AutoCompleteAddress
                                        address={address}
                                        setAddress={setAddress}
                                        location={location}
                                        formik={formik}
                                        setlocation={setlocation}
                                    />
                                    {formik.errors.address && (
                                        <div className='fv-plugins-message-container'>
                                            <div className='fv-help-block'>
                                                <span role='alert'>{formik.errors.address}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div> */}

                            <div className='grid'>
                                <div className='fv-row mb-7'>
                                    <label className='fw-bold fs-6 mb-2' style={{ backgroundColor: "white" }}>Street</label>
                                    {/* <AutoCompleteAddress
                                        address={address}
                                        setAddress={setAddress}
                                        location={location}
                                        formik={formik}
                                        setlocation={setlocation}
                                    /> */}
                                    <div style={{ pointerEvents: 'none', opacity: 0.6 }}>
                                        <AutoCompleteAddress
                                            address={address}
                                            setAddress={setAddress}
                                            location={location}
                                            formik={formik}
                                            setlocation={setlocation}
                                        />
                                    </div>
                                    {formik.errors.street && formik.touched.street && (
                                        <div className='fv-plugins-message-container'>
                                            <div className='fv-help-block'>
                                                <span role='alert'>{formik.errors.street}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            {/* <div className='grid grid-cols-2 gap-2'>
                                {inputForm({ label: 'Latitude', name: 'latitute', placeholder: 'Enter Latitude' })}
                                {inputForm({ label: 'Longitude', name: 'longitute', placeholder: 'Enter Longitude' })}
                            </div> */}


                            <div className='grid grid-cols-2 gap-2'>
                                {inputForm({ label: 'Latitude', name: 'latitute', placeholder: 'Enter Latitude', disabled: true })}
                                {inputForm({ label: 'Longitude', name: 'longitute', placeholder: 'Enter Longitude', disabled: true })}
                            </div>



                            <div className="form-group">
                                <label className="form-label fw-bold" htmlFor="zipcode">Zipcode</label>
                                <input
                                    type="text"
                                    id="zipcode"
                                    {...formik.getFieldProps('zipcode')}
                                    className={`form-input ${formik.touched.zipcode && formik.errors.zipcode ? 'error' : ''}`}
                                />
                                {formik.touched.zipcode && formik.errors.zipcode && (
                                    <div className="error-message">{formik.errors.zipcode}</div>
                                )}
                            </div>
                        </div>

                        <div className="form-divider"></div>

                        {/* Right Side Fields */}
                        <div className="form-column">
                            {/* <div className="form-group">
                                <label className="form-label fw-bold" htmlFor="gstNumber">GST Number</label>
                                <input
                                    type="text"
                                    id="gstNumber"
                                    {...formik.getFieldProps('gstNumber')}
                                    className={`form-input ${formik.touched.gstNumber && formik.errors.gstNumber ? 'error' : ''}`}
                                />
                                {formik.touched.gstNumber && formik.errors.gstNumber && (
                                    <div className="error-message">{formik.errors.gstNumber}</div>
                                )}
                            </div> */}

                            <div className="form-group">
                                <label className="form-label fw-bold" htmlFor="aadhar">Aadhar</label>
                                <input
                                    type="text"
                                    id="aadhar"
                                    {...formik.getFieldProps('aadhar')}
                                    className={`form-input ${formik.touched.aadhar && formik.errors.aadhar ? 'error' : ''}`}
                                />
                                {formik.touched.aadhar && formik.errors.aadhar && (
                                    <div className="error-message">{formik.errors.aadhar}</div>
                                )}
                            </div>

                            <div className="form-group">
                                <label className="form-label  fw-bold" htmlFor="panNumber">PAN Number</label>
                                <input
                                    type="text"
                                    id="panNumber"
                                    {...formik.getFieldProps('panNumber')}
                                    className={`form-input ${formik.touched.panNumber && formik.errors.panNumber ? 'error' : ''}`}
                                />
                                {formik.touched.panNumber && formik.errors.panNumber && (
                                    <div className="error-message">{formik.errors.panNumber}</div>
                                )}
                            </div>

                            <div className="form-group">
                                <label className="form-label fw-bold" htmlFor="ifscCode">IFSC Code</label>
                                <div className="ifsc-container">
                                    <input
                                        type="text"
                                        id="ifscCode"
                                        {...formik.getFieldProps('ifscCode')}
                                        className={`ifsc-input ${formik.touched.ifscCode && formik.errors.ifscCode ? 'error' : ''}`}
                                    />
                                    <button
                                        type="button"
                                        onClick={fetchIfscDetails}
                                        className="ifsc-search-button"
                                        disabled={loading}
                                    >
                                        {loading ? 'Loading...' : 'Search'}
                                    </button>
                                </div>
                                {formik.touched.ifscCode && formik.errors.ifscCode && (
                                    <div className="error-message">{formik.errors.ifscCode}</div>
                                )}

                                {formik.values.ifscDetails && (
                                    <div className="ifsc-details-container">
                                        <div className="ifsc-detail-item">
                                            <span className="detail-label">Bank Name:</span>
                                            <span className="detail-value">{formik.values.ifscDetails.BANK}</span>
                                        </div>
                                        <div className="ifsc-detail-item">
                                            <span className="detail-label">Branch:</span>
                                            <span className="detail-value">{formik.values.ifscDetails.BRANCH}</span>
                                        </div>
                                        <div className="ifsc-detail-item">
                                            <span className="detail-label">Address:</span>
                                            <span className="detail-value">{formik.values.ifscDetails.ADDRESS}</span>
                                        </div>
                                        <div className="ifsc-detail-item">
                                            <span className="detail-label">MICR:</span>
                                            <span className="detail-value">{formik.values.ifscDetails.MICR}</span>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {formik.values.ifscDetails && (
                                <>
                                    <div className="form-group">
                                        <label className="form-label fw-bold" htmlFor="accountNumber">Account Number</label>
                                        <input
                                            type="text"
                                            id="accountNumber"
                                            {...formik.getFieldProps('accountNumber')}
                                            className={`form-input ${formik.touched.accountNumber && formik.errors.accountNumber ? 'error' : ''}`}
                                        />
                                        {formik.touched.accountNumber && formik.errors.accountNumber && (
                                            <div className="error-message">{formik.errors.accountNumber}</div>
                                        )}
                                    </div>

                                    <div className="form-group">
                                        <label className="form-label fw-bold" htmlFor="accountHolderName">Account Holder Name</label>
                                        <input
                                            type="text"
                                            id="accountHolderName"
                                            {...formik.getFieldProps('accountHolderName')}
                                            className={`form-input ${formik.touched.accountHolderName && formik.errors.accountHolderName ? 'error' : ''}`}
                                        />
                                        {formik.touched.accountHolderName && formik.errors.accountHolderName && (
                                            <div className="error-message">{formik.errors.accountHolderName}</div>
                                        )}
                                    </div>
                                </>
                            )}

                            {/* <div className="form-group-container">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="msmeFile"></label>
                                    <UploadImage name='msmeFile' formik={formik} label='Upload MSME Certificate' />
                                </div>

                                <div className="form-group">
                                    <label className="form-label" htmlFor="Cheque"></label>
                                    <UploadImage name='Cheque' formik={formik} label='Upload Cancel Cheque' />
                                </div>
                            </div>
                            <div className="form-group-container">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="gstCer"></label>
                                    <UploadImage name='gstCer' formik={formik} label='Upload GST Certificate' />
                                </div>

                                <div className="form-group">
                                    <label className="form-label" htmlFor="PanU"></label>
                                    <UploadImage name='PanU' formik={formik} label='Upload Pan' />
                                </div>
                            </div> */}

                            <div className="form-group-container">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="msmeFile"></label>
                                    <UploadImage name='msmeFile' formik={formik} label='Upload MSME Certificate' />
                                    {fileErrors.msmeFile && (
                                        <div className="error-message">{fileErrors.msmeFile}</div>
                                    )}
                                </div>

                                <div className="form-group">
                                    <label className="form-label" htmlFor="Cheque"></label>
                                    <UploadImage name='Cheque' formik={formik} label='Upload Cancel Cheque' />
                                    {fileErrors.Cheque && (
                                        <div className="error-message">{fileErrors.Cheque}</div>
                                    )}
                                </div>
                            </div>
                            <div className="form-group-container">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="gstCer"></label>
                                    <UploadImage name='gstCer' formik={formik} label='Upload GST Certificate' />
                                    {fileErrors.gstCer && (
                                        <div className="error-message">{fileErrors.gstCer}</div>
                                    )}
                                </div>

                                <div className="form-group">
                                    <label className="form-label" htmlFor="PanU"></label>
                                    <UploadImage name='PanU' formik={formik} label='Upload Pan' />
                                    {fileErrors.PanU && (
                                        <div className="error-message">{fileErrors.PanU}</div>
                                    )}
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="mb-6">
                        <h2 className="text-xl font-bold mb-3">Agreement</h2>
                        <div className="space-y-2">
                            <div className="flex items-center gap-2">
                                <input
                                    type="checkbox"
                                    id="termsAccepted"
                                    {...formik.getFieldProps('termsAccepted')}
                                    className="h-4 w-4"
                                />
                                <label htmlFor="termsAccepted" className="text-sm">
                                    I accept the{' '}
                                    <a
                                        href="https://www.plasticsforchange.org/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-600 hover:text-blue-800 underline"
                                    >
                                        Terms of Service
                                    </a>
                                </label>
                            </div>
                            {/* <div className="flex items-center gap-2">
                                <input
                                    type="checkbox"
                                    id="platformPoliciesAccepted"
                                    {...formik.getFieldProps('platformPoliciesAccepted')}
                                    className="h-4 w-4"
                                />
                                <label htmlFor="platformPoliciesAccepted" className="text-sm">
                                    I agree to comply with <span className="text-blue-600">platform policies</span>
                                </label>
                            </div> */}
                        </div>
                    </div>

                    <div className="action-buttons">
                        <button
                            type="button"
                            onClick={handleCancel}
                            className="button cancel-button"
                        >
                            Cancel
                        </button>

                        <button
                            type="button"
                            className="button submit-button"
                            onClick={async () => {
                                console.log('Direct click handler called');

                                try {
                                    const values = formik.values;
                                    console.log('Form values:', values);

                                    // Manual file validation
                                    const errors: {
                                        msmeFile?: string;
                                        Cheque?: string;
                                        gstCer?: string;
                                        PanU?: string;
                                    } = {};

                                    if (!values.msmeFile) errors.msmeFile = 'MSME Certificate is required';
                                    if (!values.Cheque) errors.Cheque = 'Cancel Cheque is required';
                                    if (!values.gstCer) errors.gstCer = 'GST Certificate is required';
                                    if (!values.PanU) errors.PanU = 'PAN document is required';

                                    setFileErrors(errors);

                                    if (Object.keys(errors).length > 0) {
                                        console.log('Stopping due to file errors');
                                        return;
                                    }

                                    setLoading(true);

                                    // Your actual API payload and call
                                    const payload = {
                                        firstName: values.personName,
                                        email: values.email,
                                        mobile: String(JSON.parse(localStorage.getItem('verifiedPhoneNumber') || 'null')),
                                        password: values.password,
                                        userType: "RECYCLER",
                                        countryCode: "91",
                                        franchiseId: "",
                                        status: "INACTIVE",
                                        kycDocument: [
                                            {
                                                docUrl: "",
                                                docNumber: values.aadhar,
                                                docType: "AADHAR"
                                            },
                                            {
                                                docUrl: values.gstCer,
                                                docNumber: values.gstNumber,
                                                docType: "GST_CERTIFICATE"
                                            },
                                            {
                                                docUrl: values.PanU,
                                                docNumber: values.panNumber,
                                                docType: "PAN"
                                            },
                                            {
                                                docNumber: "",
                                                docUrl: values.msmeFile,
                                                docType: "MSME_CERTIFICATE"
                                            },
                                        ],
                                        companyDetails: {
                                            name: values.entityName,
                                            companyId: "",
                                        },
                                        address: [
                                            {
                                                addressType: "OFFICE_ADDRESS",
                                                city: formik.values.city,
                                                state: formik.values.state,
                                                stateCode: formik.values.stateCode,
                                                country: formik.values.country,
                                                zipCode: values.zipcode,
                                                street: address || '',
                                                latitute: values.latitute,
                                                longitute: values.longitute,

                                            }
                                        ],
                                        bankDetails: {
                                            bankName: values.ifscDetails?.BANK || "",
                                            accountNo: values.accountNumber,
                                            ifscCode: values.ifscCode,
                                            accountName: values.accountHolderName,
                                            images: [
                                                {
                                                    // docNumber: "",
                                                    docUrl: values.Cheque,
                                                    docType: "CHEQUE_CERTIFICATE"
                                                },
                                            ]
                                        }
                                    };

                                    console.log("Payload to be submitted:", payload);

                                    const response = await axios.post(
                                        'https://pfc-backend-api.asmglobal.co.in/v1/api/user/register',
                                        payload,
                                        {
                                            headers: {
                                                'accept': 'application/json',
                                                'app-id': '3',
                                                'client-id': '101212',
                                                'Connection': 'Keep-Alive',
                                                'Content-Type': 'application/json',
                                                'User-Agent': 'okhttp/4.9.2',
                                            },
                                        }
                                    );

                                    console.log("API Response:", response.data);
                                    alert('User registered successfully!');
                                    navigate('/auth');

                                } catch (error: any) {
                                    console.error("API Error:", error);
                                    alert(error?.response?.data?.message || 'Error registering user.');
                                } finally {
                                    setLoading(false);
                                }
                            }}
                        >
                            {loading ? 'Submitting...' : 'Submit'}
                        </button>
                    </div>

                    {formik.status && <div className="error-message">{formik.status}</div>}
                </form>
            </div>






            {/* GST Validation Modal */}
            {showGstModal && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000
                    }}
                    onClick={() => setShowGstModal(false)}
                >
                    <div
                        style={{
                            background: 'white',
                            padding: '20px',
                            borderRadius: '8px',
                            maxWidth: '500px',
                            width: '90%',
                            maxHeight: '80vh',
                            overflowY: 'auto'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '20px',
                            borderBottom: '1px solid #eee',
                            paddingBottom: '10px'
                        }}>
                            <h3>GST Details Verified</h3>
                            <button
                                onClick={() => setShowGstModal(false)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '24px',
                                    cursor: 'pointer'
                                }}
                            >
                                ×
                            </button>
                        </div>
                        <div>
                            {gstDetails && (
                                <div>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        marginBottom: '10px',
                                        padding: '5px 0'
                                    }}>
                                        <strong>Business Name:</strong>
                                        <span>{gstDetails.legal_business_name}</span>
                                    </div>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        marginBottom: '10px',
                                        padding: '5px 0'
                                    }}>
                                        <strong>Trade Name:</strong>
                                        <span>{gstDetails.trade_name}</span>
                                    </div>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        marginBottom: '10px',
                                        padding: '5px 0'
                                    }}>
                                        <strong>Address:</strong>
                                        <span>{gstDetails.principal_place_of_business}</span>
                                    </div>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        marginBottom: '10px',
                                        padding: '5px 0'
                                    }}>
                                        <strong>Status:</strong>
                                        <span>{gstDetails.gstin_uin_status}</span>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div style={{ marginTop: '20px', textAlign: 'right' }}>
                            <button
                                onClick={() => setShowGstModal(false)}
                                className="btn btn-primary"
                            >
                                Continue
                            </button>
                        </div>
                    </div>
                </div>
            )}



        </div>
    );
};

export default RecyclerInformationPage;
